// import { Navigate } from "react-router-dom";
// 
// const ProtectedRoute = ({ element }) => {
//   const userEmail = localStorage.getItem("mail"); // Check email in localStorage
//   return userEmail ? element : <Navigate to="/signin" />;
// };
// 
// export default ProtectedRoute;

import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { cleanup } from "@induz/sdk";
// import init, { Sdk } from "Wasm/izwe";

const ProtectedRoute = ({ element }) => {
  const [isAllowed, setIsAllowed] = useState(null); // null = loading

  // useEffect(() => {
  //   const checkSignIn = async () => {
  //     // await init(); // Only needed once — ideally move this to app startup if possible
  //     // const result = await Sdk.is_signed_in();
  //     // setIsAllowed(result);
  //   };

  //   checkSignIn();
  // }, []);
  useEffect(() => {
    const mail=window.sessionStorage.getItem("mail");
    if(mail){
      setIsAllowed(true);
    }
    else{
      setIsAllowed(false);
    }
  }, []);
  window.addEventListener("popstate", () => {
    location.reload();
  });
  // window.addEventListener("beforeunload", () => {
  //   cleanup();
  // });

  if (isAllowed === null) {
    return null; // or a loading spinner if you want
  }

  return isAllowed ? element : <Navigate to="/signin" />;
};

export default ProtectedRoute;
